import { Container, Table } from "../../../components";
import { useContext, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import FormActa from "../../../views/Forms/FormActa";
import { useFormActaStore } from "../../../store/formActaStore";
import { cargaDatos } from "./handlers";
import { handlerGetActa, handlerMisActas } from "../../../handlers/actas.handler";
import { tableData } from "./tableData";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { useDataUserStore } from "../../../store/dataUserStore";
import AddIcon from "../../../components/svgs/AddIcon";
import { NavigateBeforeOutlined } from "@mui/icons-material";
import { UserContext } from "../../../context";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { Link, useLocation } from "react-router-dom";
import useWindowSize from "../../../hooks/useWindowSize";
import { getEdad } from "../../../utils/getEdad";
import ModalConstatacionAdmin from "../../Admin/Actas/components/ModalConstatacionAdmin";

const Actas = () => {
  const size = useWindowSize();
  const { width } = size;
  const {
    setTipos,
    setBarrios,
    setLoading,
    tipos,
    barrios,
    loading,
    defaultValues,
    setDefaultValues,
    formActive,
    setFormActive,
    ultimo_paso,
    screenMisActas,
    refetch,
    setRefetch,
  } = useFormActaStore();
  const { loads, modals } = useGeneralAppStore();
  const { misActas } = useDataUserStore();
  const [paso, setPaso] = useState();

  const { actions: ua } = useContext(UserContext);
  const perfil = ua.getPerfil();

  const path = useLocation()?.pathname;

  useEffect(() => {
    handlerMisActas();
  }, []);

  useEffect(() => {
    if (defaultValues) {
      setPaso(defaultValues?.ultimo_paso);
    } else {
      setPaso(null);
    }
  }, [defaultValues]);

  useEffect(() => {
    return () => {
      setDefaultValues(null);
      setPaso(null);
      setFormActive(false);
    };
  }, []);

  useEffect(() => {
    if (refetch) {
      handlerMisActas();
      setRefetch(false);
    }
  }, [refetch]);

  const edad = getEdad(perfil?.fechaNacimiento);

  return (
    <Container
      linkBack={
        formActive && path == "/mis_solicitudes"
          ? () => {
              setFormActive(false);
              setRefetch(true);
            }
          : "/"
      }
      tituloApp={"ARBOLADO"}
      titulo={
        !paso && !formActive
          ? "Mis solicitudes"
          : !paso && formActive
          ? "Paso 1 - Datos del ciudadano"
          : paso == 1
          ? "Paso 2 - Datos de la solicitud"
          : paso == 2
          ? // ? "Paso 3 - Adjuntar imagenes"
            "Solicitud enviada"
          : paso == 3
          ? "Paso 4 - Solicitud enviada"
          : ""
      }
      size={"sm"}
    >
      <div
        className="position-relative d-flex " /* style={{ minHeight:"80vh" }} */ /* style={{ minHeight: "60vh" }} */
      >
        {/* <AnimatePresence mode="wait"> */}
        {!formActive && (
          <motion.div
            key="table"
            // className="w-100 co-12 position-absolute"
            className="w-100 co-12 "
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            // initial={{ x: !defaultValues ? 0 : -100, opacity: 0 }}
            // animate={{ x: 0, opacity: 1 }}
            // exit={{ x: -100, opacity: 0 }}
            // transition={{ delay: 0.5, duration: 0.5, ease: "easeInOut" }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            style={{ overflow: "hidden", minWidth: "100%", minHeight: "455px" }}
          >
            <Table
              rowHeight={80}
              height={"65vh"}
              loading={["mis_actas", "get_acta"].some((item) => loads.includes(item))}
              data={tableData(misActas, width, path)}
              rowClick={(params) => {
                if (path == "/mis_solicitudes") {
                  handlerGetActa(params.row.id);
                }
              }}
            />
          </motion.div>
        )}

        {/* <button
          disabled={loading}
          className={`btn ${formActive ? "btn-primary" : "btn-success"} btn-sm position-absolute`}
          style={{ top: "-50px " }}
          onClick={() => {
            formActive && handlerMisActas();
            setFormActive(!formActive),
              !formActive
                ? setDefaultValues({
                  nombre_ciudadano: perfil.nombre,
                  dni: perfil.documento,
                  edad: getEdad(perfil?.fechaNacimiento),
                  genero: perfil.genero,
                  domicilio: perfil.direccion.split("-")[0],
                  telefono: perfil.celular,
                  email: perfil.correoElectronico,
                  barrio_id: "",
                  ultimo_paso: 0,
                })
                : setDefaultValues(null);
          }}
        >
          {formActive ? <NavigateBeforeOutlined /> : <AddIcon height={"24"} />}{" "}
          {formActive ? "Mis actas" : "Nueva solicitud"}
        </button> */}

        {formActive && <FormActa />}
      </div>
    </Container>
  );
};
export default Actas;
